export default (response) => {
  process.env.NODE_ENV === 'development' &&
    console.log('API - SUCCESS', response.status, response.config.method, response.config.url, response)
  return response.data
}
